import React from 'react';
import {connect} from 'react-redux';
import {closeAction} from '../../actions/Cookie';
import {Link} from 'react-router';

class CookieDisclaimer extends React.Component {
    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
    }

    close() {
        this.props.dispatch(closeAction());
    }

    render() {
        if (!this.props.cookieClosed) {
            return <div className="cookie-disclaimer">
                <div className="container">
                    <div className="msg-box">Този сайт използва бисквитки (cookies) за повишаване на ефективността си. <Link to="/cookies">Научи повече</Link></div>
                    <button onClick={this.close} className="close btn btn-default" type="button">Разбрах</button>
                </div>
            </div>
        }
        else {
            return null;
        }
    }
}

const mapStateToProps = (state) => {
    return {
        cookieClosed: state.cookie.cookieDisclaimerClosed
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps)(CookieDisclaimer);


// WEBPACK FOOTER //
// ./src/components/Containers/CookieDisclamer.js